"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var NRDAsyncMetric = /*#__PURE__*/function () {
  function NRDAsyncMetric(logger, eventId) {
    var logToSignalFX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, NRDAsyncMetric);

    this.logger = logger;
    this.eventId = eventId;
    this.startTime = Date.now();
    this.logToSignalFX = logToSignalFX;
  }

  _createClass(NRDAsyncMetric, [{
    key: "success",
    value: function success(log) {
      if (!log.hasOwnProperty('appContext')) {
        log.appContext = {};
      }

      log.appContext.success = true;
      this.createLog(log);
    }
  }, {
    key: "failure",
    value: function failure(log) {
      if (!log.hasOwnProperty('appContext')) {
        log.appContext = {};
      }

      log.appContext.success = false;
      this.createLog(log);
    }
  }, {
    key: "createLog",
    value: function createLog(log) {
      this.endTime = Date.now();
      log = _objectSpread({}, log, {
        startMillis: this.startTime,
        endMillis: this.endTime,
        eventId: this.eventId
      });

      if (this.logToSignalFX) {
        this.perfSummary = _objectSpread(_defineProperty({}, this.eventId, [this.endTime - this.startTime]), log.perfSummary);
        log = _objectSpread({}, log, {
          perfSummary: this.perfSummary
        });
      }

      this.logger.metric(log);
    }
  }]);

  return NRDAsyncMetric;
}();

exports["default"] = NRDAsyncMetric;